import { render, staticRenderFns } from "./PartnerAgreement.vue?vue&type=template&id=b74d945c&scoped=true&"
import script from "./PartnerAgreement.vue?vue&type=script&lang=js&"
export * from "./PartnerAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74d945c",
  null
  
)

export default component.exports